import React from "react";
import SocialLinks from "../constants/socialLinks";

const Footer = () => {
  return (
    <footer className="footer">
      <SocialLinks styleClass="social-icons" />

      <p>Made with 🤎 by Sumesh Majhi</p>
    </footer>
  );
};

export default Footer;
